import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useStore } from '../../Components/useStore'
import { socialLinks, marketplaceLinks } from '../../Utils/Data'
import PaymentMethods from '../../Components/PaymentMethods'

const PHONE_DISPLAY = '+966 55 269 0995'
const PHONE_WA = '966552690995'
const EMAIL = 'sslimfast2000@gmail.com'

const exploreLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Slimfast' },
  { to: '/ingredients', label: 'Ingredients' },
  { to: '/shop', label: 'Shop' },
  { to: '/contact', label: 'Contact' },
]

const shopLinks = [
  { to: '/cart', label: 'Cart' },
  { to: '/checkout', label: 'Checkout' },
  { to: '/dashboard', label: 'My Account' },
  { to: '/dashboard?tab=wishlist', label: 'Wishlist' },
  { to: '/dashboard?tab=history', label: 'Order History' },
]

function Footer() {
  const year = new Date().getFullYear()
  const { state } = useStore()
  const isLoggedIn = Boolean(state.UserInfo?.token)
  const [email, setEmail] = useState('')

  const handleSubscribe = (e) => {
    e.preventDefault()
    const value = email.trim()
    if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      toast.error('Please enter a valid email address')
      return
    }
    toast.success('Thanks for subscribing!')
    setEmail('')
  }

  return (
    <footer className="footer-section bg2 position-relative overflow-hidden">
      <div className="footer-top pt-120">
        <div className="container">
          <div className="turbu-newsletter style1 d-flex align-items-center justify-content-md-between justify-content-center text-md-start text-center gap-4 pb-xxl-19 pb-xl-15 pb-lg-10 pb-8">
            <div className="footer-turbu-info">
              <Link to="/" className="footer-logo d-block mb-xxl-6 mb-xl-4 mb-4">
                <img
                  src="/assets/images/logo/slimfast-whiteheader-logo.png?v=5"
                  alt="Slimfast"
                  style={{ maxHeight: 64, width: 'auto', display: 'block' }}
                />
              </Link>
              <p className="footer-pragraph fs-six fw-400 body-font pp-clr mb-4">
                Slim Fast is a specialized store offering health and wellness
                products, dedicated to supporting customers on their journey
                toward a more balanced and vibrant lifestyle.
              </p>
              <div className="d-flex flex-column gap-1 mb-4 text-start fs14 pp-clr">
                <span>
                  Slimfast is owned and operated by{' '}
                  <b>QUALITY TECHNOLOGIES FOR TRADING SERVICES HOLDING COMPANY</b>.
                </span>
                <span>
                  VAT Number: <b>311649097900003</b>
                </span>
                <span>
                  Commercial Registration (CR): <b>7034896436</b>
                </span>
              </div>
              <ul className="social-wrap d-flex justify-content-center justify-content-md-start align-items-center gap-xxl-3 gap-2 flex-wrap mb-4">
                {socialLinks.map((item, index) => (
                  <li key={item.id}>
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      className={`soc-item d-inline-flex radius-circle justify-content-center align-items-center${
                        index > 0 ? ' soc-item-hover-black n4-border' : ''
                      }`}
                      aria-label={item.label}
                    >
                      <i className={`ph-bold ${item.icon} fs-five`} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="subscribe-newsletter">
              <h4 className="n900-clr mb-xxl-6 mb-4">Subscribe Newsletter</h4>
              <form
                onSubmit={handleSubscribe}
                className="subscribe-form d-flex gap-sm-3 gap-2"
              >
                <input
                  type="email"
                  placeholder="Enter email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  className="fs-seven n0-clr fw-500 n900-bg radius12 text-center py-4 px-md-6 px-4 text-nowrap"
                >
                  Subscribe Now
                </button>
              </form>
            </div>
          </div>

          <div className="row g-0 footer-border-maintain">
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
              <div className="footer-items py-xxl-18 py-xl-15 py-lg-10 py-8">
                <h4 className="n900-clr mb-xxl-8 mb-xl-5 mb-lg-4 mb-3">Explore</h4>
                <ul className="footer-item-link d-flex flex-column gap-xxl-4 gap-2">
                  {exploreLinks.map((link) => (
                    <li key={link.to}>
                      <Link to={link.to} className="fs18 fw-500 n900-clr hover-act4">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-xl-3 footer-border col-lg-3 col-md-6 col-sm-6">
              <div className="footer-items py-xxl-18 py-xl-15 py-lg-10 py-8 ps-xl-15 ps-9">
                <h4 className="n900-clr mb-xxl-8 mb-xl-5 mb-lg-4 mb-3">Shop & Account</h4>
                <ul className="footer-item-link d-grid gap-xxl-4 gap-2">
                  {shopLinks.map((link) => (
                    <li key={link.to}>
                      <Link to={link.to} className="fs18 fw-500 n900-clr hover-act4">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                  <li>
                    <Link
                      to={isLoggedIn ? '/dashboard' : '/sign-in'}
                      className="fs18 fw-500 n900-clr hover-act4"
                    >
                      {isLoggedIn ? 'Dashboard' : 'Sign In'}
                    </Link>
                  </li>
                  {!isLoggedIn && (
                    <li>
                      <Link to="/sign-up" className="fs18 fw-500 n900-clr hover-act4">
                        Sign Up
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            <div className="col-xl-3 footer-border col-lg-3 col-md-6 col-sm-6">
              <div className="footer-items py-xxl-18 py-xl-15 py-lg-10 py-8 ps-xl-15 ps-9">
                <h4 className="n900-clr mb-xxl-8 mb-xl-5 mb-lg-4 mb-3">Our Shops</h4>
                <ul className="footer-item-link d-grid gap-xxl-4 gap-2">
                  {marketplaceLinks.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fs18 fw-500 n900-clr hover-act4"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-xl-3 footer-border col-lg-3 col-md-6 col-sm-6">
              <div className="footer-items py-xxl-18 py-xl-15 py-lg-10 py-8 ps-xl-15 ps-9">
                <h4 className="n900-clr mb-xxl-8 mb-xl-5 mb-lg-4 mb-3">Contact Info</h4>
                <div className="d-grid gap-xxl-5 gap-4">
                  <a
                    href={`https://wa.me/${PHONE_WA}`}
                    target="_blank"
                    rel="noreferrer"
                    className="fs18 d-flex align-items-center gap-sm-3 gap-2 n900-clr body-font hover-act4"
                  >
                    <i className="ph-fill ph-phone-call fs20" />
                    {PHONE_DISPLAY}
                  </a>
                  <a
                    href={`mailto:${EMAIL}`}
                    className="fs18 d-flex align-items-center gap-sm-3 gap-2 n900-clr body-font hover-act4"
                  >
                    <i className="ph-fill ph-chats fs20" />
                    {EMAIL}
                  </a>
                  <Link
                    to="/contact"
                    className="fs18 d-flex align-items-center gap-sm-3 gap-2 n900-clr body-font hover-act4"
                  >
                    <i className="ph-fill ph-map-pin fs20" />
                    Saudi Arabia • Contact us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="privacy-policy-footer">
        <div className="container">
          <div className="d-flex flex-wrap pb-xxl-8 pb-xl-6 pb-4 pt-xxl-8 pt-xl-6 pt-4 n4-bt gap-3 align-items-center justify-content-md-between justify-content-center">
            <div className="d-flex flex-column gap-3 align-items-center align-items-md-start">
              <p className="footer-copyright flex-wrap justify-content-center n900-clr mb-0">
                <span className="copy n900-clr fs18">
                  Copyright © {year}{' '}
                  <Link to="/" className="n900-clr">
                    SlimFast
                  </Link>
                </span>
              </p>
              <PaymentMethods variant="footer" />
            </div>
            <ul className="pri-link d-flex align-items-center gap-xxl-6 gap-sm-6 gap-3 mb-0">
              <li>
                <Link to="/contact" className="n900-clr hover-act4 fs18">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/shop" className="n900-clr hover-act4 fs18">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/ingredients" className="n900-clr hover-act4 fs18">
                  Ingredients
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
